import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 13.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm-18 4.5c0-4.586 1.472-8.826 3.966-12.28.268-.37-.036-.89-.482-.796C10.69 6.872 3.824 15.428 4.552 25.458c.662 9.114 7.842 16.732 16.908 17.88 5.274.67 10.19-.78 14.04-3.6.368-.27.184-.838-.27-.886C24.704 37.718 16.5 28.828 16.5 18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.44 21.44l2.121 2.121m3.879-2.121l2.121 2.121m-2.121-8.182l2.12 2.121"
  }))
};
export var WeatherNightClear = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});